import Tooltip from '@liveauctioneers/caterwaul-components/lib/Tooltip/Tooltip';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';
import styled, { css, useTheme } from 'styled-components';

import useIsNarrowerThan from '@/hooks/useIsNarrowerThan';

type WhyCantRetractBidPopoverProps = {
    newItemCardCTA?: boolean;
};

const WhyCantRetractBidPopover = ({ newItemCardCTA }: WhyCantRetractBidPopoverProps) => {
    const {
        breakpoints: { tabletNarrowWidthNum },
    } = useTheme();
    const isMobile = useIsNarrowerThan(tabletNarrowWidthNum + 1);

    const newMyBidsItemCardText = () => {
        if (newItemCardCTA) {
            if (isMobile) {
                return 'retract';
            }
            return 'retract_bid';
        } else {
            return 'retract';
        }
    };

    return (
        <StyledContainer $newItemCardCTA={newItemCardCTA}>
            <Tooltip
                placement="top"
                trigger={
                    <StyledTextTrigger
                        $newItemCardCTA={newItemCardCTA}
                        role="button"
                        tabIndex={0}
                    >
                        <FormattedMessage id={newMyBidsItemCardText()} />
                    </StyledTextTrigger>
                }
            >
                <FormattedMessage id="why_cant_i_retract_bid_popover_text" />
            </Tooltip>
        </StyledContainer>
    );
};

export default WhyCantRetractBidPopover;

const StyledTextTrigger = styled.div<{ $newItemCardCTA?: boolean }>`
    max-width: 100px;
    color: ${({ theme }) => theme.colors.grey100};

    &:hover {
        color: ${({ theme }) => theme.colors.grey100};
    }

    ${({ $newItemCardCTA }) =>
        $newItemCardCTA &&
        css`
            max-width: 100%;
        `}
`;

const StyledContainer = styled.div<{ $newItemCardCTA?: boolean }>`
    ${({ $newItemCardCTA }) =>
        $newItemCardCTA &&
        css`
            & > div > div {
                max-width: 100%;
            }
        `}
`;
